var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 31 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4597",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Search results for Pin - Flaticon-3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8508"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8507"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8506",
    fill: "#191919"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7439",
    d: "M11.866 0A8.876 8.876 0 0 0 3 8.866a10.229 10.229 0 0 0 .752 3.413A14.3 14.3 0 0 0 4.777 14.2l6.079 9.21a1.156 1.156 0 0 0 2.02 0l6.079-9.21a14.239 14.239 0 0 0 1.025-1.917 10.226 10.226 0 0 0 .752-3.413A8.876 8.876 0 0 0 11.866 0Zm7.154 11.874a13.1 13.1 0 0 1-.934 1.747l-6.079 9.211c-.12.182-.158.182-.278 0L5.65 13.621a13.106 13.106 0 0 1-.934-1.748 9.285 9.285 0 0 1-.671-3.008 7.823 7.823 0 0 1 15.645 0 9.292 9.292 0 0 1-.67 3.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7440",
    d: "M11.866 4.173a4.694 4.694 0 1 0 4.694 4.694 4.7 4.7 0 0 0-4.694-4.694Zm0 8.344a3.651 3.651 0 1 1 3.651-3.651 3.655 3.655 0 0 1-3.651 3.651Z"
  })))))));
};
export default SvgLocation;